export const args = {
    title: 'Saidatta Sahu',
    title_secondary: '6 Day',
    subtitle: 'Software Engineer',
    avatar: 'https://reactnative.dev/img/tiny_logo.png',
    location: 'Bangalore, India',
};
export const argTypes = {};
